import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import ConfirmButton from '../ConfirmButton';

const styles = theme => ({
  acceptInvitationWarning: {
    fontWeight:700,
    display:'block',
    marginBottom: 16
  },
  acceptInvitation: {
    display:'block'
  },
})

const DomainRegistrationButton = ({
  classes,
  //invitation,
  domain,
  disabled,
  productName,
  handleRegisterDomain,
  size="medium",
  variant="text",
  ...props,
}) => (
  <ConfirmButton
    size={size}
    style={!disabled? {color:"#6AA031"}: null}
    variant={variant}
    disabled={disabled}
    //working={invitation.accepting}
    onClick={handleRegisterDomain}
    message={
      <div>
        <div>
          <FormattedMessage 
            id="subscription.domains.confirmation.registerDomain.description" 
            values={{
                domain,
                productName
            }}  
          />
        </div>
        <div>
          <FormattedMessage 
            id="subscription.domains.confirmation.registerDomain.descriptionSecond"
            values={{domain}}
          />
        </div>
      </div>
    }
    yes={
      <FormattedMessage id='subscription.domains.confirmation.registerDomain.button.confirm' />
    }
    no={
      <FormattedMessage id='subscription.domains.confirmation.registerDomain.button.cancel' />
    }
    title={
      <FormattedMessage id='subscription.domains.confirmation.registerDomain.title' />
    }
    {...props}
  >
    <FormattedMessage id='subscription.domains.register.button.registerDomain' />
  </ConfirmButton>
);

DomainRegistrationButton.propTypes = {
  classes: PropTypes.object.isRequired,
  //invitation: PropTypes.object.isRequired,
  handleRegisterDomain: PropTypes.func,
}

export default withStyles(styles)(
  DomainRegistrationButton
);


// WEBPACK FOOTER //
// ./src/components/domains/DomainRegistrationButton.js